<!-- Bookmark.svelte -->
<script>
    import { fly } from "svelte/transition";
    import { createEventDispatcher } from "svelte";
  
    // Parent will pass `show` as a prop (true if the user is a new user).
    export let show = false;
  
    // We'll dispatch an event to the parent so it can set `show = false`.
    const dispatch = createEventDispatcher();
  
    function autoBookmark() {
      const url = window.location.href;
      const title = document.title;
  
      // Firefox < 23
      if (window.sidebar && window.sidebar.addPanel) {
        window.sidebar.addPanel(title, url, "");
      }
      // IE
      else if (window.external && "AddFavorite" in window.external) {
        window.external.AddFavorite(url, title);
      }
      // Opera < 15
      else if (window.opera && window.print) {
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("title", title);
        a.setAttribute("rel", "sidebar");
        a.click();
      }
      // If not supported (e.g., modern Chrome)
      else {
        alert("Press Ctrl + D (Windows) or Cmd + D (Mac) to bookmark.");
      }
  
      // As soon as user clicks the bookmark button (and dismisses any alert),
      // we dispatch 'close' so the parent can hide this component.
      dispatch("close");
    }
  
    function closeBox() {
      // If user clicks the X, also dispatch 'close'
      dispatch("close");
    }
  </script>
  
  {#if show}
    <!-- Slide down more slowly from the top, centered horizontally. -->
    <div
      class="bookmark-wrapper"
      in:fly={{ y: -300, duration: 1500 }}
      out:fly={{ y: -300, duration: 700 }}
    >
      <button class="close-button" on:click={closeBox}>
        &times;
      </button>
      <button class="bookmark-button" on:click={autoBookmark}>
        Bookmark AI Cloaker
      </button>
    </div>
  {/if}
  
  <style>
    .bookmark-wrapper {
      position: fixed;
      top: 10px; /* keep it near the top */
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.4rem 0.8rem;
      border-radius: 0.5rem;
      background: rgba(19, 21, 26, 0.8);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      z-index: 9999999; /* ensure it's above everything else */
    }
  
    .close-button {
      background: transparent;
      color: #e2e8f0;
      border: none;
      font-size: 1.2rem;
      cursor: pointer;
      line-height: 1;
    }
  
    .bookmark-button {
      background: #424867;
      color: #e2e8f0;
      border: none;
      border-radius: 8px;
      padding: 0.4rem 0.8rem;
      cursor: pointer;
      font-size: 1rem;
      white-space: nowrap;
      transition: 0.3s ease;
      animation: pulse 1.5s infinite;
    }
  
    .bookmark-button:hover {
      background: #646cff;
    }
  
    @keyframes pulse {
      0% {
        transform: scale(1);
        box-shadow: none;
      }
      70% {
        transform: scale(1.05);
        box-shadow: 0 0 15px rgba(100, 108, 255, 0.7);
      }
      100% {
        transform: scale(1);
        box-shadow: none;
      }
    }
  </style>
  